import React from 'react';

type BrandMarkProps = {
  variant?: 'header' | 'login' | 'hero';
  className?: string;
};

/** ITI wordmark: Morse symbol :|:, set in Inter via --font-family-brand */
export const BrandMark: React.FC<BrandMarkProps> = ({ variant = 'header', className = '' }) => (
  <span
    className={['brand-mark', `brand-mark--${variant}`, className].filter(Boolean).join(' ')}
    role="img"
    aria-label="ITI"
  >
    :|:
  </span>
);
